import { render, staticRenderFns } from "./userPrivateAgree.vue?vue&type=template&id=afd924ea"
import script from "./userPrivateAgree.vue?vue&type=script&lang=js"
export * from "./userPrivateAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports